import { RESOURCES } from "./resources";

/**
 * Qué permiso hace falta para ASIGNAR un pago a proveedores o un cobro.
 *
 * Lo leen tres lugares y tienen que decir lo mismo: el guard de la ruta de
 * asignar (`routes.tsx`), el mapa ruta → recurso del menú (`routeResources.ts`) y
 * los botones «Asignar ahora» que aparecen al crear el pago o el cobro. Cuando
 * cada uno escribía el suyo, el mapa mandaba a los pagos a `disbursement/payables`
 * y el guard a `disbursement/disbursements`.
 *
 * - **Cobros**: `collection/collections`, distinto del que se pide para
 *   cargarlos (`collection/deposits`). Quien carga cobros no necesariamente los
 *   asigna.
 * - **Pagos**: `disbursement/disbursements`, el mismo que se pide para cargarlos.
 *   Es el guard que la ruta tuvo siempre (nació como `/compras/pagos` con permiso
 *   de escritura): quien puede cargar un pago puede asignarlo. El catálogo de
 *   roles también ofrece `disbursement/payables` («Cuentas a pagar»), pero
 *   exigirlo acá le sacaría la pantalla a quien hoy tiene Pagos y no ese
 *   recurso; si eso se quiere, es una decisión de permisos aparte, no de este
 *   mapa.
 */
export const RECURSO_PARA_ASIGNAR = {
  pago: RESOURCES.DISBURSEMENT_DISBURSEMENTS,
  cobro: RESOURCES.COLLECTION_COLLECTIONS,
} as const;
